// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-sort-icons {\n    height: 10px;\n}\n\n.container-sort-icons i {\n    cursor: pointer;\n    display: block;\n    height: 5px;\n}\n\n.container-sort-icons i.hidden {\n    display: none;\n}", ""]);
// Exports
module.exports = exports;
